// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--1h29F","wrapperLetter":"wrapperLetter--2Rth2","button":"button--Gtqsp","paragraph":"paragraph--StyBq"};